// prismjs color theme
require('./src/styles/prism.css')
